var _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 76,
    viewBox: "0 0 74 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_743_3206)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.0931,
    cy: 40.8946,
    r: 18.7341,
    transform: "rotate(-84.1811 33.0931 40.8946)",
    fill: "url(#paint0_linear_743_3206)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.9402,
    y: 3.17285,
    width: 15.435,
    height: 37.044,
    rx: 1,
    fill: "url(#paint1_linear_743_3206)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.63501,
    y: -3.91406,
    width: 72.8271,
    height: 79.9141
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_743_3206_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_743_3206)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.462 31.1705V62.5664C69.462 64.0075 68.8928 65.3895 67.8797 66.4085C66.8666 67.4275 65.4925 68 64.0597 68H50.5541C49.1214 68 47.7473 67.4275 46.7342 66.4085C45.721 65.3895 45.1519 64.0075 45.1519 62.5664V48.9824C45.1519 48.2619 44.8673 47.5709 44.3607 47.0614C43.8542 46.5519 43.1671 46.2656 42.4507 46.2656H31.6462C30.9299 46.2656 30.2428 46.5519 29.7363 47.0614C29.2297 47.5709 28.9451 48.2619 28.9451 48.9824V62.5664C28.9451 64.0075 28.376 65.3895 27.3628 66.4085C26.3497 67.4275 24.9756 68 23.5429 68H10.0373C8.60449 68 7.23041 67.4275 6.21729 66.4085C5.20417 65.3895 4.63501 64.0075 4.63501 62.5664V31.1705C4.6349 30.4185 4.78998 29.6746 5.09046 28.986C5.39093 28.2974 5.83025 27.679 6.38061 27.17L33.3919 1.53704L33.429 1.49969C34.4235 0.590013 35.7194 0.0859375 37.0637 0.0859375C38.4079 0.0859375 39.7039 0.590013 40.6984 1.49969C40.7099 1.51297 40.7223 1.52546 40.7355 1.53704L67.7468 27.17C68.2916 27.6817 68.7253 28.3013 69.0205 28.9898C69.3157 29.6782 69.466 30.4207 69.462 31.1705Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 31.1705V62.5664C69.462 64.0075 68.8928 65.3895 67.8797 66.4085C66.8666 67.4275 65.4925 68 64.0597 68H50.5541C49.1214 68 47.7473 67.4275 46.7342 66.4085C45.721 65.3895 45.1519 64.0075 45.1519 62.5664V48.9824C45.1519 48.2619 44.8673 47.5709 44.3607 47.0614C43.8542 46.5519 43.1671 46.2656 42.4507 46.2656H31.6462C30.9299 46.2656 30.2428 46.5519 29.7363 47.0614C29.2297 47.5709 28.9451 48.2619 28.9451 48.9824V62.5664C28.9451 64.0075 28.376 65.3895 27.3628 66.4085C26.3497 67.4275 24.9756 68 23.5429 68H10.0373C8.60449 68 7.23041 67.4275 6.21729 66.4085C5.20417 65.3895 4.63501 64.0075 4.63501 62.5664V31.1705C4.6349 30.4185 4.78998 29.6746 5.09046 28.986C5.39093 28.2974 5.83025 27.679 6.38061 27.17L33.3919 1.53704L33.429 1.49969C34.4235 0.590013 35.7194 0.0859375 37.0637 0.0859375C38.4079 0.0859375 39.7039 0.590013 40.6984 1.49969C40.7099 1.51297 40.7223 1.52546 40.7355 1.53704L67.7468 27.17C68.2916 27.6817 68.7253 28.3013 69.0205 28.9898C69.3157 29.6782 69.466 30.4207 69.462 31.1705Z",
    fill: "url(#paint2_linear_743_3206)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0637 0.585938C38.2825 0.585943 39.4581 1.04279 40.3606 1.86816V1.86719C40.3708 1.87753 40.3802 1.88861 40.3909 1.89844V1.89941L67.4026 27.5322L67.4045 27.5342C67.899 27.9986 68.2927 28.5613 68.5608 29.1865C68.8289 29.8119 68.9658 30.4868 68.9622 31.168V62.5664C68.9622 63.8758 68.4443 65.1307 67.5247 66.0557C66.6051 66.9805 65.359 67.5 64.0598 67.5H50.554C49.2548 67.5 48.0086 66.9805 47.0891 66.0557C46.1694 65.1307 45.6516 63.8758 45.6516 62.5664V48.9824C45.6516 48.1302 45.3151 47.3125 44.7151 46.709C44.115 46.1054 43.3003 45.7656 42.4504 45.7656H31.6467C30.7969 45.7656 29.9822 46.1055 29.3821 46.709C28.7821 47.3125 28.4456 48.1302 28.4456 48.9824V62.5664C28.4456 63.8758 27.9277 65.1307 27.0081 66.0557C26.0886 66.9805 24.8423 67.4999 23.5432 67.5H10.0374C8.73813 67.5 7.49111 66.9806 6.57153 66.0557C5.65207 65.1307 5.13501 63.8756 5.13501 62.5664V31.1699C5.13497 30.4868 5.27622 29.8109 5.54907 29.1855C5.82196 28.5603 6.22061 27.999 6.71997 27.5371L6.72485 27.5322L33.7356 1.89941L33.7415 1.89453L33.7747 1.86133C34.6762 1.04038 35.8484 0.585938 37.0637 0.585938Z",
    stroke: "url(#paint3_linear_743_3206)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_743_3206",
    x: 0.357422,
    y: 8.15894,
    width: 65.4712,
    height: 65.4712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_743_3206"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_743_3206",
    x: 0.63501,
    y: -3.91406,
    width: 72.8271,
    height: 79.9141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3206",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_743_3206_clip_path",
    transform: "translate(-0.63501 3.91406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.462 31.1705V62.5664C69.462 64.0075 68.8928 65.3895 67.8797 66.4085C66.8666 67.4275 65.4925 68 64.0597 68H50.5541C49.1214 68 47.7473 67.4275 46.7342 66.4085C45.721 65.3895 45.1519 64.0075 45.1519 62.5664V48.9824C45.1519 48.2619 44.8673 47.5709 44.3607 47.0614C43.8542 46.5519 43.1671 46.2656 42.4507 46.2656H31.6462C30.9299 46.2656 30.2428 46.5519 29.7363 47.0614C29.2297 47.5709 28.9451 48.2619 28.9451 48.9824V62.5664C28.9451 64.0075 28.376 65.3895 27.3628 66.4085C26.3497 67.4275 24.9756 68 23.5429 68H10.0373C8.60449 68 7.23041 67.4275 6.21729 66.4085C5.20417 65.3895 4.63501 64.0075 4.63501 62.5664V31.1705C4.6349 30.4185 4.78998 29.6746 5.09046 28.986C5.39093 28.2974 5.83025 27.679 6.38061 27.17L33.3919 1.53704L33.429 1.49969C34.4235 0.590013 35.7194 0.0859375 37.0637 0.0859375C38.4079 0.0859375 39.7039 0.590013 40.6984 1.49969C40.7099 1.51297 40.7223 1.52546 40.7355 1.53704L67.7468 27.17C68.2916 27.6817 68.7253 28.3013 69.0205 28.9898C69.3157 29.6782 69.466 30.4207 69.462 31.1705Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3206",
    x1: 30.9891,
    y1: 41.0155,
    x2: 43.5046,
    y2: 54.2012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3206",
    x1: 58.6577,
    y1: 3.17285,
    x2: 58.6577,
    y2: 40.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3206",
    x1: 4.63501,
    y1: 0.0859375,
    x2: 81.4124,
    y2: 18.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3206",
    x1: 62.9794,
    y1: 74.7914,
    x2: 1.4196,
    y2: 4.60395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon06);
export default __webpack_public_path__ + "static/media/service-icon06.798d3fbdb2a78fd68c9406a9c0ae4ac1.svg";
export { ForwardRef as ReactComponent };